let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6vn11")).then(() => parcelRequire('iaimi'));